import { Reveal, Chapter } from "../components/Reveal";
import { CtaSection } from "./Home";
import { ADP_TOWNS, EXPERIENCE_GROUPS } from "../data/content";

export default function Experiencia() {
    return (
        <>
            <section
                className="mx-auto max-w-7xl px-6 pb-28 pt-40 lg:px-10 lg:pt-48"
                data-testid="experiencia-page"
            >
                <div className="grid gap-16 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <Reveal>
                            <Chapter num={1} label="Grandes obras" />
                            <h1
                                className="mt-8 font-display text-5xl font-black uppercase leading-[1.0] tracking-tight sm:text-6xl"
                                data-testid="experiencia-title"
                            >
                                A nossa{" "}
                                <span className="text-brand">experiência.</span>
                            </h1>
                            <p className="mt-8 max-w-lg text-sm leading-relaxed text-zinc-400 md:text-base">
                                Ao longo dos anos, participámos em alguns dos
                                mais relevantes projetos de infraestruturas em
                                Portugal, contribuindo com a nossa experiência,
                                capacidade operacional e uma frota preparada
                                para responder aos desafios de cada obra.
                            </p>
                        </Reveal>
                        <Reveal delay={0.15}>
                            <div
                                className="mt-12 border border-brand/50 bg-coal p-8 lg:p-10"
                                data-testid="experiencia-adp-card"
                            >
                                <p className="font-mono text-xs font-bold uppercase tracking-[0.35em] text-brand">
                                    Desde 2005
                                </p>
                                <h2 className="mt-4 font-display text-3xl font-black uppercase tracking-tight">
                                    Águas de Portugal
                                </h2>
                                <div className="mt-6 flex flex-wrap gap-2">
                                    {ADP_TOWNS.map((t) => (
                                        <span
                                            key={t}
                                            className="border border-white/15 px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-400"
                                        >
                                            {t}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-7">
                        {EXPERIENCE_GROUPS.map((g, gi) => (
                            <Reveal key={g.id} delay={gi * 0.1}>
                                <div
                                    className={gi > 0 ? "mt-12" : ""}
                                    data-testid={`experiencia-group-${g.id}`}
                                >
                                    <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
                                        {g.label}
                                    </h3>
                                    <div className="mt-5 flex flex-wrap gap-2">
                                        {g.items.map((item) => (
                                            <span
                                                key={item}
                                                className="border border-white/10 bg-coal px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.12em] text-zinc-300 transition-colors duration-300 hover:border-brand hover:text-white"
                                            >
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </section>
            <CtaSection />
        </>
    );
}
